import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const useCoachProfile = (profileId?: string) => {
  return useQuery({
    queryKey: ['coach-profile', profileId],
    queryFn: async () => {
      if (!profileId) return null;

      const { data, error } = await supabase
        .from('coach_profiles')
        .select('*')
        .eq('profile_id', profileId)
        .maybeSingle();

      if (error) {
        console.error('Error fetching coach profile:', error);
        return null;
      }

      return data;
    },
    enabled: !!profileId
  });
};

export const useMyCoachProfile = () => {
  return useQuery({
    queryKey: ['my-coach-profile'],
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return null;

      // Get profile id first
      const { data: profile } = await supabase
        .from('profiles')
        .select('id')
        .eq('user_id', user.id)
        .single();

      if (!profile) return null;

      const { data, error } = await supabase
        .from('coach_profiles')
        .select('*')
        .eq('profile_id', profile.id)
        .maybeSingle();

      if (error) {
        console.error('Error fetching coach profile:', error);
        return null;
      }

      return data;
    }
  });
};
